import { useState, useEffect } from "react";

// External Libraries
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";

// Styling
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils";
import { useMediaQuery, MEDIA_QUERY_BELOW_XL } from "sj-ui-toolkit/src/hooks";
import S from "../_styles.module.scss";

// Sandbox context hook(s)
import { useInstructionDetails, useInteraction } from "../contexts/SandboxHooks";

// Sub-components
import Instructions from "./Instructions";
import Tasks from "./Tasks";

const SandboxText = () => {
  const [showFinishButton, setShowFinishButton] = useState(false);
  const { instructions, hasFinishButton } = useInstructionDetails();
  const { maxStepCompleted, reportAllStepsCompleted } = useInteraction();
  const isStacked = useMediaQuery(MEDIA_QUERY_BELOW_XL);

  useEffect(() => {
    // Determine if the Finish Lesson button should be shown
    const shouldShowFinishButton =
      hasFinishButton &&
      maxStepCompleted !== null &&
      instructions?.steps &&
      maxStepCompleted === instructions.steps.length - 1;

    setShowFinishButton(!!shouldShowFinishButton);
  }, [hasFinishButton, maxStepCompleted, instructions?.steps]);

  const handleFinishClick = async () => {
    await reportAllStepsCompleted();
    // Additional logic for finishing the lesson can be added here
  };

  return (
    <>
      <div className={C(S.sandboxTextContainer)}>
        <TabView
          aria-label="Lesson content"
          pt={{
            // Sticky bar needs an opaque bg matching whatever it sits on at each breakpoint.
            navContainer: {
              className: C("sticky top-0 z-2", isStacked ? T.bgElevation2 : T.bgElevation0),
            },
            nav: { className: "atlas-h5" },
            inkbar: { className: T.bgGray300 },
            panelContainer: { className: C(isStacked ? T.bgElevation2 : T.bgElevation0, "p-0") },
          }}
        >
          <TabPanel header="Instructions">
            <Instructions steps={instructions?.steps ?? []} />
          </TabPanel>
          {instructions?.tasks && instructions.tasks.length > 0 && (
            <TabPanel header="Tasks">
              <Tasks tasks={instructions.tasks} />
            </TabPanel>
          )}
        </TabView>
        <div className={C("mt-4", S.finishButtonContainer)}>
          {
            showFinishButton ? (
              <Button onClick={handleFinishClick} className={C("btn btn-primary", S.finishButton)}>
                Finish Lesson
              </Button>
            ) : (
              <div className="h-10"></div>
            ) /* Placeholder to prevent layout shift when button appears */
          }
        </div>
      </div>
    </>
  );
};

export default SandboxText;
